/* eslint-disable import/no-cycle */
import useApiHelpers from '@/composables/api/helpers';
import { useBuyOrderFormStore } from '@/stores/forms/buyOrderFormStore';
import { useSellOrderFormStore } from '@/stores/forms/sellOrderFormStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

export default function useTracker() {
  const getOrderMode = () => {
    try {
      const raw = localStorage.getItem('mode');
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  const getSellOrderData = () => {
    const { getTrackingInformation } = useSellOrderFormStore();
    return getTrackingInformation;
  };

  const getBuyOrderData = () => {
    const { getTrackingInformation } = useBuyOrderFormStore();
    return getTrackingInformation;
  };

  const getMerchApiOrderData = () => {
    const merch = useOrderFormStore().merchApiOrderData;
    if (!merch || typeof merch !== 'object' || Object.keys(merch).length === 0) {
      return {};
    }
    return {
      fiatAmount: merch.fiatAmount,
      fiatType: merch.fiatType,
      coinAmount: merch.coinAmount,
      coinType: merch.coinType,
      paymentMethod: merch.payment ?? merch.paymentMethod ?? merch.paymentType,
    };
  };

  const getOrderData = () => {
    const mode = getOrderMode()?.toLowerCase();
    let orderData = {};
    if (mode) {
      switch (mode) {
        case 'buy':
          orderData = { ...getBuyOrderData() };
          break;
        case 'sell':
          orderData = { ...getSellOrderData() };
          break;
        default:
          break;
      }
    }

    if (orderData && Object.keys(orderData).length > 0) {
      return orderData;
    }

    return getMerchApiOrderData();
  };

  const sendTrackerEvent = async (event = {}) => {
    const { postRequest } = useApiHelpers();
    const { host, pathname, referrer } = window.location;
    const defaultData = {
      page: {
        host,
        pathname,
        referrer,
      },
      order: {
        ...getOrderData(),
      },
    };

    const {
      type = 'FRONTEND_ORDER_JOURNEY',
      subtype = 'PAGE_VISIT',
      data,
    } = event;

    try {
      const response = await postRequest('/track', {
        data: {
          ...defaultData,
          ...data,
        },
        event_type: type,
        event_sub_type: subtype,
      });
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  return {
    sendTrackerEvent,
  };
}

export const sendConversionTrackEvent = (eventName, payload = {}) => {
  const { sendTrackerEvent } = useTracker();
  sendTrackerEvent({
    type: 'FRONTEND_ORDER_JOURNEY',
    subtype: eventName,
    data: payload,
  }).catch(() => {
    // fail silent — tracking must not affect checkout
  });
};
